import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBillTos } from "@insite/client-framework/Services/CustomersService";
import { chain, FindDefaultBillTo } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";

replaceInChain(chain, FindDefaultBillTo, async props => {
    const billToCollection = await getBillTos({pageSize:8 });
    const billTos = billToCollection.billTos!;

    if (billTos.length === 1) {
        props.defaultBillTo = billTos[0];
    } else {
        const defaultBillTos = billTos.filter(o => o.isDefault);

        if (defaultBillTos.length === 1) {
            props.defaultBillTo = defaultBillTos[0];
        }
    }
})